export default __webpack_public_path__ + "static/img-pacific-snapper-500x325-f6339ed863ded8ba81210fcb35968ac2.png";